import { useEffect, useLayoutEffect } from 'react';

import { hasWindow } from 'utils/browser.utils';

export const useEnhancedEffect = hasWindow() ? useLayoutEffect : useEffect;
